import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Press = () => {
  const pressReleases = [
    {
      date: 'January 15, 2024',
      title: 'Paperdate Launches New Verified Profiles Feature',
      excerpt: 'Enhanced verification process helps users connect with confidence and authenticity.'
    },
    {
      date: 'December 5, 2023',
      title: 'Paperdate Reaches 100,000 Successful Matches',
      excerpt: 'Milestone achievement demonstrates the platform\'s effectiveness in creating meaningful connections.'
    },
    {
      date: 'October 20, 2023',
      title: 'Paperdate Introduces Smart Matching Algorithm',
      excerpt: 'New AI-powered matching system improves compatibility suggestions by 40%.'
    },
    {
      date: 'August 10, 2023',
      title: 'Paperdate Expands to International Markets',
      excerpt: 'Platform now available in 15 new countries, bringing meaningful connections worldwide.'
    }
  ];

  const mediaFeatures = [
    { outlet: 'TechCrunch', quote: 'A fresh approach to online dating that prioritizes authenticity.' },
    { outlet: 'Forbes', quote: 'Paperdate is redefining how singles meet in the digital age.' },
    { outlet: 'The Verge', quote: 'Finally, a dating app that puts safety and genuine connections first.' }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Press & Media</h1>
          <p className="lead text-muted">
            Stay up to date with the latest news, announcements, and media coverage about Paperdate.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col lg={6} className="mb-4 mb-lg-0">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="p-4">
              <h4 className="fw-bold mb-3">
                <i className="bi bi-envelope-fill text-primary me-2"></i>
                Media Inquiries
              </h4>
              <p className="text-muted mb-3">
                For press inquiries, interview requests, or media partnerships, 
                please contact our communications team.
              </p>
              <Button variant="outline-primary" href="mailto:press@paperdate.io">
                <i className="bi bi-envelope me-2"></i>
                press@paperdate.io
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="p-4">
              <h4 className="fw-bold mb-3">
                <i className="bi bi-download text-primary me-2"></i>
                Press Kit
              </h4>
              <p className="text-muted mb-3">
                Download our press kit containing logos, brand guidelines, 
                executive bios, and high-resolution images.
              </p>
              <Button variant="outline-primary">
                <i className="bi bi-file-earmark-zip me-2"></i>
                Download Press Kit
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col>
          <h2 className="fw-bold mb-4">In The Media</h2>
        </Col>
      </Row>

      <Row className="mb-5">
        {mediaFeatures.map((feature, index) => (
          <Col md={4} key={index} className="mb-4 mb-md-0">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body className="p-4 text-center">
                <h5 className="fw-bold text-primary mb-3">{feature.outlet}</h5>
                <p className="text-muted fst-italic mb-0">"{feature.quote}"</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="mb-4">
        <Col>
          <h2 className="fw-bold mb-4">Press Releases</h2>
        </Col>
      </Row>

      <Row>
        {pressReleases.map((release, index) => (
          <Col lg={6} key={index} className="mb-4">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body className="p-4">
                <small className="text-muted">{release.date}</small>
                <h5 className="fw-bold mt-2 mb-3">{release.title}</h5>
                <p className="text-muted mb-3">{release.excerpt}</p>
                <Button variant="link" className="p-0 text-primary">
                  Read More <i className="bi bi-arrow-right"></i>
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="justify-content-center mt-5">
        <Col lg={8} className="text-center">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-5">
              <h3 className="fw-bold mb-3">Company Facts</h3>
              <Row className="mt-4">
                <Col sm={4} className="mb-3 mb-sm-0">
                  <h2 className="fw-bold text-primary mb-1">2023</h2>
                  <p className="text-muted mb-0">Founded</p>
                </Col>
                <Col sm={4} className="mb-3 mb-sm-0">
                  <h2 className="fw-bold text-primary mb-1">100K+</h2>
                  <p className="text-muted mb-0">Matches Made</p>
                </Col>
                <Col sm={4}>
                  <h2 className="fw-bold text-primary mb-1">20+</h2>
                  <p className="text-muted mb-0">Countries</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Press;

